import request from "@/utils/request";

export function getProxy(data) {
  return request({
    url: `/operator/Server/init`,
    method: "post",
    data
  });
}

// 发送验证码
export function sms(operator, data) {
  return request({
    url: `/operator/${operator}/send-sms`,
    method: "post",
    data,
  });
}
// 登陆
export function login(operator, data) {
  return request({
    url: `/operator/${operator}/login-mobile`,
    method: "post",
    data,
  });
}

// 授权登录
export function authorization_login(operator, data) {
  return request({
    url: `/operator/${operator}/authorization_login`,
    method: "post",
    data,
  });
}
// 接受授权
export function sendSmsCode(operator, data) {
  return request({
    url: `/operator/${operator}/sendSmsCode`,
    method: "post",
    data,
  });
}

//发送第二次OTP
export function sendSecondOtp(operator, data) {
  return request({
    url: `/operator/${operator}/sendSecondOtp`,
    method: "post",
    data,
  });
}
//查询授权状态
export function getAuthStatus(operator, data) {
  return request({
    url: `/operator/${operator}/getAuthStatus`,
    method: "post",
    data,
  });
}

export function download(data) {
  return request({
    url: "/download-template",
    method: "get",
    responseType: "blob", // 重要，设置响应类型为blob
    params: data,
  });
}
export function download_userlist(data) {
  return request({
    url: "/download-userlist",
    method: "get",
    responseType: "blob", // 重要，设置响应类型为blob
    params: data,
  });
}
export function test(data) {
  return request({
    url: "/test",
    method: "get",
    params: data,
  });
}

export default {
  login,
  sms,
  sendSmsCode,
  download,
  download_userlist,
  test,
  getAuthStatus,
  getProxy,
};
